import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ o("path", { d: "M21.362 5H2.638C1.74 5 1 5.722 1 6.6v12.8c0 .878.74 1.6 1.638 1.6h18.724C22.26 21 23 20.278 23 19.4V6.6c0-.878-.74-1.6-1.638-1.6Zm-.759 1.371-8.435 8.238c-.093.092-.243.092-.327 0L3.397 6.371h17.206Zm.759 13.258H2.638a.23.23 0 0 1-.234-.229V7.34l8.435 8.238c.318.311.74.467 1.161.467.421 0 .843-.156 1.16-.467l8.436-8.237V19.4a.23.23 0 0 1-.234.229Z" }, null, -1), r = [
  n
];
function l(s, a) {
  return e(), t("svg", c, [...r]);
}
const h = { render: l };
export {
  h as default,
  l as render
};
